angular.module('invoice')
    .constant('InvoiceCostConst', {
        eventUpdate: 'invoice-cost.updated'
    })
    .factory('InvoiceCost', function ($resource) {
        return $resource('/crm/api/invoice-cost/:id', {id: '@id'}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/invoice-cost/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/invoice-cost/table-statistics'},
        })
    })
    .component('invoiceCostList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/invoice/cost/list.html',
        controller: function ($scope, $state, $stateParams, $httpParamSerializer, InvoiceCostConst, Invoice, Currency, InvoiceService, TableSelection) {
            this.reset = () => this.filters = {filter: this.filters.filter}

            this.$onInit = () => {
                this.selection = TableSelection.create(this.page.list, selected => {
                    this.statistics.selected = InvoiceService.sumInvoicesByCurrency(selected.map(item => ({currency: item.invoice?.currency, pricing: item.price})))
                })
                Currency.list().$promise.then(items => items.map(c => c.symbol)).then(items => this.currencies = items)
                Invoice.statuses().$promise.then(items => this.documentStatuses = items)
                Invoice.types().$promise.then(items => this.documentTypes = items)
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-cost-batch/export?" + $httpParamSerializer(paramsAll)
            }

            this.searchFieldPopover = `
                <div>Prefiksy:</div>
                <div><b>df*</b> - nr dokumentu</div>
                <div><b>fvz*</b> - nr dok. księg.</div>
                <div><b>spr*</b> - sprzedawca (symbol, nazwa, nip)</div>
                <div><b>nab*</b> - nabywca (symbol, nazwa, nip)</div>
                <div><b>net*</b> - wartość netto od__do</div>
                <div><b>vat*</b> - wartość VAT od__do</div>
                <div><b>bru*</b> - wartość brutto od__do</div>
            `

            $scope.$on(InvoiceCostConst.eventUpdate, () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceCostList', {
            parent: 'app',
            url: '/invoice-cost?{page:int}&{size:int}&sort&search&periodStart&periodEnd&saleStart&saleEnd&status&type&documentType&currency&worker&seller&buyer&filter&documentStatus&category&project&costCenter&costType&customFilter&{amountNetFrom:number}&{amountNetTo:number}',
            data: {
                authorities: ['ROLE_INVOICE_DOCUMENTS_MODULE']
            },
            params: {
                documentType: {array: true, value: [], squash: false},
                documentStatus: {array: true, value: [], squash: false},
                filter: {value: 'company-assigned'}
            },
            views: {
                'content@': 'invoiceCostList'
            },
            resolve: {
                statistics: (InvoiceCost, $stateParams) => InvoiceCost.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceCost, $stateParams) => InvoiceCost.table(angular.copy($stateParams)).$promise
            }
        })
    })
